import React from 'react';
import { FiMenu } from 'react-icons/fi';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import S from './Widget.module.scss';

const WidgetHeaderControls = ({
  titleKey,
  title,
  selectOptions = [],
  selectedValue,
  onSelectChange,
  showMenuButton = true,
  headerAction = null,
}) => {
  const resolvedTitle = titleKey ? checkMot(titleKey) : title;
  const showSelect =
    Array.isArray(selectOptions) &&
    selectOptions.length > 1 &&
    typeof selectedValue !== 'undefined' &&
    typeof onSelectChange === 'function';

  return (
    <div className={S.dashboardWidgetHeader}>
      <div className={S.dashboardHeaderControls}>
        <h3 className={S.dashboardWidgetTitle}>{resolvedTitle}</h3>
        {showSelect && (
          <select
            className={S.dashboardWidgetSelect}
            value={selectedValue}
            onChange={(event) => onSelectChange(event.target.value)}
          >
            {selectOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.labelKey ? checkMot(option.labelKey) : option.label}
              </option>
            ))}
          </select>
        )}
      </div>
      <div className={S.dashboardHeaderControls}>
        {headerAction}
        {showMenuButton && (
          <button className={S.widgetMenuBtn}>
            <FiMenu size={18} />
          </button>
        )}
      </div>
    </div>
  );
};

export default WidgetHeaderControls;
